var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMicrosoft(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10 1H1V10H10V1Z",
    fill: "#F25022"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10 11H1V20H10V11Z",
    fill: "#00A4EF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M20 1H11V10H20V1Z",
    fill: "#7FBA00"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M20 11H11V20H20V11Z",
    fill: "#FFB900"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMicrosoft);
export default __webpack_public_path__ + "static/media/microsoft.30fae3fb0806bf2d1bcc9d68e45d1a57.svg";
export { ForwardRef as ReactComponent };